import React, { Component, } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, } from 'reactstrap'
import { db } from '../../config/firebaseconfig'
import timestamper from '../../helpers/timestamper'

const uuid = require('uuid/v1')

class AddSchoolsModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      street1: '',
      street2: '',
      city: '',
      state: '',
      zip: '',
      sfid: '',
      isSaving: false,
      error: '',
    }

    this.input = React.createRef()
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  cancel(id) {
    this.setState({
      name: '',
      street1: '',
      street2: '',
      city: '',
      state: '',
      zip: '',
      sfid: '',
      isSaving: false,
    })
    this.props.toggle(id)
  }
 
  addSchool() {
    this.setState({isSaving: true})
    let error = ''
    if (!this.state.name) {
      error = 'Name field is required.'
    } else if (!this.state.state) {
      error = 'State field is required.'
    }
    if (error) {
      this.setState({isSaving: false, error})
    } else {
      const id = uuid()
      const time = timestamper()
      const batch = db.batch()
      const schoolsRef = db.collection('schools').doc(id)
      const districtsRef = db.collection('districts').doc(this.props.selectedDistrict)

      batch.set(schoolsRef, {
        id,
        teachers: {},
        admins: {},
        state: this.state.state,
        name: this.state.name,
        address: {
          street1: this.state.street1,
          street2: this.state.street2,
          city: this.state.city,
          state: this.state.state,
          zip: this.state.zip,
        },
        classes: {},
        schoolResults: {},
        district: this.props.selectedDistrict,
        created: time,
        lastModified: time,
        students: {},
        sfid: this.state.sfid,
      })
      const schoolsKey = `schools.${id}`
      batch.update(districtsRef, {[schoolsKey]: true, lastModified: time})
      batch.commit()
        .then(() => this.cancel(id))
        .catch((error) => {
           this.setState({error: 'Error saving district to database.'})
        })
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.input.current.focus()
    }
  }

  handleKeyPress(key) {
    if (key === 'Enter' && !this.state.isSaving) {
      this.addSchool()
    }
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={'modal-primary'}>
        <ModalHeader toggle={this.props.toggle}>Add School</ModalHeader>
        <ModalBody>
          <Form onKeyPress={(e) => this.handleKeyPress(e.key)}>
            <FormGroup>
              <Label htmlFor='name'>School Name</Label>
              <Input 
                type='text' 
                id='name' 
                name='name' 
                placeholder='XYZ School' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.name}
                className={this.state.error === 'Name field is required.' && !this.state.name ? 'is-invalid' : null}              
                innerRef={this.input}
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='street1'>Street Address</Label>
              <Input
                type='text'
                id='street1'
                name='street1'
                placeholder='First line of street address'
                onChange={(e) => this.handleChange(e)}
                value={this.state.street1}
              />
              <Input
                type='text'
                id='street2'
                name='street2'
                placeholder='Second line of street address'
                onChange={(e) => this.handleChange(e)}
                value={this.state.street2}
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='city'>City</Label>
              <Input
                type='text'
                id='city'
                name='city'
                placeholder='ABC City'
                onChange={(e) => this.handleChange(e)}
                value={this.state.city}
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='state'>State</Label>
              <Input
                type='text'
                id='state'
                name='state'
                placeholder='XY'
                onChange={(e) => this.handleChange(e)}
                value={this.state.state}
                className={this.state.error === 'State field is required.' && !this.state.state ? 'is-invalid' : null}
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='zip'>Zip Code</Label>
              <Input
                type='text'
                id='zip'
                name='zip'
                placeholder='99989'
                onChange={(e) => this.handleChange(e)}
                value={this.state.zip}
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='sfid'>SF Id</Label>
              <Input
                type='text'
                id='sfid'
                name='sfid'
                placeholder='001i000000Jdw9d'
                onChange={(e) => this.handleChange(e)}
                value={this.state.sfid}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          {this.state.error ? `${this.state.error}` : ''}
          <Button className={'ml-2'} color='primary' onClick={() => this.addSchool()}>+ Add School</Button>
          <Button onClick={() => this.cancel()} color='secondary'>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default AddSchoolsModal


// WEBPACK FOOTER //
// ./src/components/Users/AddSchoolsModal.js